export const Home = () => {
  return (
    <div className="h-screen w-full">
      <iframe
        src="https://ruanyifeng.com/"
        title="阮一峰的个人网站"
        className="w-full h-full border-0"
        loading="lazy"
        sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
      />
    </div>
  );
};